module.exports = __webpack_public_path__ + "img/button_service_on.75c302d1.png";